import Cookies from 'js-cookie';

// export const AUTH_TOKEN = window.localStorage.getItem('.token');
export const AUTH_TOKEN =
  'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjQzNzMxMTQ2ODQzOTA3Njg3NiIsInVzZXJuYW1lIjoiY2xpY2s4Njg3IiwiYXZhdGFyIjoiYTgwZTUwMzUwYTE5NzUyMWE3MDI3OWEwMzMwMDFhMDEiLCJkaXNjcmltaW5hdG9yIjoiMCIsInB1YmxpY19mbGFncyI6MCwicHJlbWl1bV90eXBlIjowLCJmbGFncyI6MCwiYmFubmVyIjpudWxsLCJhY2NlbnRfY29sb3IiOjcwOTU1NDYsImdsb2JhbF9uYW1lIjoiQ2xpY2siLCJhdmF0YXJfZGVjb3JhdGlvbl9kYXRhIjpudWxsLCJiYW5uZXJfY29sb3IiOiIjNmM0NGZhIiwibWZhX2VuYWJsZWQiOmZhbHNlLCJsb2NhbGUiOiJydSIsImVtYWlsIjoic2FzaGFrdXNobmlyNDk5MUBnbWFpbC5jb20iLCJ2ZXJpZmllZCI6dHJ1ZSwiYWNjZXNzX3Rva2VuIjoiYUtRZVhtMXBmOUJjRFNOZ0RUYVF5VEF1ZGQyNktjIiwiaWF0IjoxNzA3MjA5MjU2fQ.plr1a1rOaAn8IuONPcLMD3UMCbUg172u-9NZAtNGPlk';

export const getToken = () => {
  return Cookies.get('id_token');
};

export const setToken = (token, expires) => {
  if (!token) {
    return Cookies.remove('id_token');
  }
  return Cookies.set('id_token', token, {expires: expires || 365});
};
